<div [hidden]="!ViewReady">
    <div class="heading">
        <div class="title">{{NomineeType?.Description}} Nomination Form</div>
    </div>
    <div class="mainpanel">
        <p *ngIf="PhotoWindowSet === false" class="redicon nomInfo">Photo Window Not Set!</p>
        <div *ngIf="FormWindowOpen !== true"><strong>Note:</strong> The nomination form window for submitting this form has closed. No submissions can be made at this time.</div>
        <div *ngIf="NominationForm">
            <div [formGroup]="NominationForm">
                <div fxLayout="row wrap" fxLayoutAlign="start start" formArrayName="Sections">
                    <div *ngFor="let sec of NominationForm.get('Sections')?.controls; let $index = index" fxFlex="25" class="customtab" [class.active]="SelectedTabIndex === $index" (click)="ChangeTab($index)" [formGroup]="sec">
                        <mat-icon *ngIf="sec.get('SectionReady')?.value !== true" class="redicon">report_problem</mat-icon>
                        <mat-icon *ngIf="sec.get('SectionReady')?.value === true" class="greenicon">done</mat-icon>
                        <span>{{sec.get('Name')?.value}}</span>
                    </div>
                </div>
                <ng-container formArrayName="Sections">
                    <ng-container *ngFor="let sec of NominationForm?.get('Sections')?.controls; let $index = index" [formGroup]="sec">
                        <div *ngIf="SelectedTabIndex === $index">
                            <!-- Form Panel -->
                            <app-form-panel *ngIf="sec.get('IsAttachment')?.value !== true" [IsNominee]="true" [Section]="sec"></app-form-panel>
                            <!-- Attachment Panel -->
                            <ng-container *ngIf="sec.get('IsAttachment')?.value">
                                <h2 class="mat-headline primarycolor500">{{sec.get('AttachmentType')?.value?.Description}}</h2>
                                <app-publicattachmentpanel [AttachmentType]="sec.get('AttachmentType')?.value" [FileWindowDeadline]="FileWindowDeadline" [NomineeType]="NomineeType" [Instructions]="sec.get('Instructions')?.value" [SiteName]="SiteName" (uploaded)="GetAttachment($event)"></app-publicattachmentpanel>
                            </ng-container>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
            <div class="submit">
                <div class="bottomMargin">
                    <button type="button" mat-raised-button color="warn" (click)="SaveForm()">
                        <mat-icon>cloud_upload</mat-icon>
                        <span>Submit Form</span>
                    </button>
                    <div class="red" *ngIf="ShowFormWarning === true">Please complete every form question in each one of the tabs</div>
                    <div class="red" *ngIf="ShowPhotoWarning === true">Please upload a photo</div>
                    <div class="red" *ngIf="ShowCaptchaWarning === true">Please complete the captcha</div>
                    <div class="red" *ngIf="ShowSubmittedWarning === true">You have already successfully submitted this application</div>
                </div>
                <re-captcha (resolved)="captcha($event)" siteKey="6LeCA_EbAAAAAPHToN5nEoLQCajqy5ceIrq0664T"></re-captcha>
                <small>Do captcha immediately before submitting form.<br />It may expire otherwise.</small>
            </div>
        </div>
    </div>
</div>